import React from 'react';
import { VLink } from '../../other/vLink';
import { Block } from '../../other/block';

interface ActionProps {
  heading: string;
  subheading: string;
  actionLabel: string;
  actionLink: string;
  backgroundColour?: string;
}

export const Action: React.FC<ActionProps> = ({ heading, subheading, actionLabel, actionLink, backgroundColour }) => {
  return (
    <Block backgroundColour={backgroundColour} className="text-center">
      <h2 className="text-3xl font-semibold mb-10 leading-none">{heading}</h2>
      <h3 className="leading-none mb-12">{subheading}</h3>
      <VLink to={actionLink} className="bg-green-700 text-white text-white px-6 py-2 inline-block rounded">
        {actionLabel}
      </VLink>
    </Block>
  );
};
